// extracted by mini-css-extract-plugin
export var couponCard = "styles-module__couponCard___CBW4u";
export var actionButton = "styles-module__actionButton___cJpjR";